var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidebarApplication',{ref:"sidebarApplication",attrs:{"workspace":_vm.workspace,"application":_vm.application,"highlighted":_vm.isAppSelected(_vm.application)},on:{"selected":_vm.selected},scopedSlots:_vm._u([(_vm.isAppSelected(_vm.application))?{key:"body",fn:function(){return undefined},proxy:true}:null],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }